export const routeCategory = {
  river: 'river',
  ocean: 'ocean',
  airplane: 'airplane',
  example: 'example',
};
